<template>
    <section class="banner -wrap-no-margins">
        <slot />
    </section>
</template>

<script>
    export default {
        props: {
            image: String
        }
    }
</script>

<style lang="scss" scoped>
    .banner {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        background-color: $bright_gray;
        position: relative;

        [class*="desktop"] & {
            min-height: 300px;
        }
    }
</style>
